import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { DamagedUtilitiesComponent } from './damaged-utilities.component'
import { DamagedUtilityDashboardComponent } from './damaged-utility-dashboard.component'

@Component({
    selector: 'app-damaged-utility-log',
    templateUrl: './damaged-utility-log.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        DamagedUtilityDashboardComponent,
        DamagedUtilitiesComponent,
    ],
})
export class DamagedUtilityLogComponent extends BaseComponent {
    @ViewChild(DamagedUtilityDashboardComponent)
    dashboard?: DamagedUtilityDashboardComponent

    activeTab = 0

    constructor() {
        super()
        // Users without dashboard access land directly on the Records tab.
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsDamagedUtilityLogDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
